import {
  fontKnockoutHeavyweight,
  fontKnockoutLightweight
} from "@fdr/static-ui/Typography";
import styled, { css } from "styled-components";
import buildColor from "@fdr/static-ui/ColorPalette";
import Icon from "@fdr/static-ui/Icons";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

export const StoryBookWrapper = styled.div`
  background-color: "#1F273F";
`;

export const Row = styled.div`
  display: flex;
  flex-flow: row nowrap;
  align-items: flex-end;
  justify-content: space-between;
`;

export const Column = styled.div`
  display: flex;
  flex-flow: column nowrap;
`;

export const LeafIcon = styled(Icon)`
  margin-bottom: 7px;
  width: 24px;
  height: 40px;
  &:not(:first-child) {
    margin-left: 11px;
  }
  &:first-child {
    transform: rotateY(180deg);
    margin-right: 11px;
  }
`;

const boldText = css`
  b {
    color: ${buildColor("yellow")};
    font-weight: inherit;
  }
`;

export const DerbyTitle = styled.div<{
  hasEventEnded: boolean;
  $fontSize: number;
}>`
  ${({ hasEventEnded }) =>
    css`
      font-family: ${hasEventEnded
        ? fontKnockoutHeavyweight
        : fontKnockoutLightweight};
    `}
  letter-spacing: 1px;
  font-weight: 400;
  color: ${buildColor("white", "100")};
  line-height: 1;
  margin: 0;
  text-align: center;
  text-transform: uppercase;
  display: flex;
  flex-flow: row wrap;
  align-items: center;
  justify-content: center;
  column-gap: 7px;
  ${({ hasEventEnded, $fontSize }) =>
    css`
      font-size: ${hasEventEnded ? 18 : $fontSize}px;
    `}
  ${boldText}
`;
